import moment from "moment";
import Data from "app-core/Data";
import Config from "app-core/config";
import Vue from "vue";
import qs from 'query-string';
import _ from "lodash";
import VueI18n from "vue-i18n";
import {makeCategory} from "app-core/helpers/locales-parser";
import Promise from 'bluebird';
import auth from 'auth';

const state = Vue.observable({
	currentLocale: {},
	availableLocales: [],
	storedTranslations: null
});

export function getAppLocale(fallbackLocale = 'en-EN') {
	const qsObj = qs.parse(location.search);
	let queryStringLocale = qsObj.lang;
	const localStorageLocale = localStorage.getItem('locale');
	const browserLocale = window.navigator.language.split('-')[0];
	return queryStringLocale || (`${localStorageLocale}` !== 'undefined' && `${localStorageLocale}` !== 'null' ? localStorageLocale : null) || browserLocale || fallbackLocale;
}

const actions = {
	setCurrentLocale: async function () {
		const appLocaleCode = getAppLocale();

		if (!state.availableLocales.length) {
			await this.getAvailableLocales();
		}

		let locale = state.availableLocales.find(locale => locale.code === appLocaleCode)
		if (!locale)
			locale = state.availableLocales.find(locale => `${locale.code}`.split('-')[0].toLowerCase() === `${appLocaleCode}`.split('-')[0].toLowerCase())
		
		if (locale) {
			state.currentLocale = locale;
		} else {
			state.currentLocale = state.availableLocales.find(locale => locale.code === 'en-EN');
		}

		if (!state.currentLocale) {
			state.currentLocale = { id: 'en-US', code: 'en-US', label: 'English' };
		}

		if (__DEBUG__)
			console.debug('SetCurrentLocale', { appLocaleCode, locale, current: state.currentLocale });
	},
	getDefaultLocaleTranslations: function() {
		return require('./default-locale.json');
	},
	getAvailableLocales: async function (forceReload) {
		if (state.availableLocales && state.availableLocales.length && !forceReload || auth.isPublishMode()) return Promise.resolve(state.availableLocales);
		const r = await Data.getAllLocales()
		const app = Config.getVueApp();
		app.$set(app.$locale.state, 'availableLocales', r);
		return r;
	},
	refreshI18n: async function (forceReload) {
		const defaultTranslations = this.getDefaultLocaleTranslations();
		await this.setCurrentLocale();
		if (state?.currentLocale?.id && (!state.storedTranslations || forceReload) && !auth.isPublishMode()) {
			state.storedTranslations = await Data.getTranslations({localeId: state?.currentLocale?.id});
		}
		const app = Config.getVueApp();
		app.$i18n.locale = state.currentLocale?.code;
		app.$i18n.setLocaleMessage(state.currentLocale?.code, this.translationsToMessages(defaultTranslations.tokens, state.storedTranslations));
	},
	changeStoredTranslation(item) {
		if (state.storedTranslations) {
			var existItem = _.find(state.storedTranslations || [], v => v.key === item.key && v.localeId === item.localeId);
			if (existItem) {
				existItem.translation = item.translation;
			}
		}
	},
	translationsToMessages(defaultTranslations, storedTranslations) {
		if (!storedTranslations) return;
		let result = {};
		defaultTranslations.forEach(item => {
			if (!result[item.category]) result[item.category] = {};
			const tr = storedTranslations.find(translation => translation.key === item.key)
			result[item.category][item.caption] = tr ? tr.translation || null : null;
		})
		result = Object.keys(result).reduce((acc, keys) => _.set(acc, keys, result[keys]), {});
		if (__DEBUG__)
			console.debug('translationsToMessages', result);
		return result;
	},
	getAppLocale
};

function tCaption(caption, path) {
	path = makeCategory(null, path, this.$options.translationCategory || 'common');
	//let translation = this.$t(`${path}.${caption}`);
	var struct = this.$i18n.messages[this.$i18n.locale];
	var paths = `${path}`.split('.');
	
	while (paths.length && struct) {
		struct = struct[paths[0]] || struct;
		paths.splice(0, 1);
	}

	const translation = (struct && struct[caption]);
	return translation || caption;
}

function i18nInit() {
	const fallbackLocale = 'en-EN';
	const defaultNumberFormat = {
		currency: {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		},
		fixed0: {
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		},
		fixed1: {
			minimumFractionDigits: 1,
			maximumFractionDigits: 1
		},
		fixed2: {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		},
		fixed3: {
			minimumFractionDigits: 3,
			maximumFractionDigits: 3
		},
		fixed4: {
			minimumFractionDigits: 4,
			maximumFractionDigits: 4
		},
		fixed5: {
			minimumFractionDigits: 5,
			maximumFractionDigits: 5
		}
	};
	const currentLocale = getAppLocale();
	const locale = {};

	const locales = {};
	locales[currentLocale] = locale;

	// Vue.use(VueI18n);

	const vueLocaleMessages = {};
	vueLocaleMessages[currentLocale] = locale.messages;
	const vueLocaleNumberFormats = {};
	vueLocaleNumberFormats[currentLocale] = _.merge(locale.numberFormats || {}, defaultNumberFormat);

	const vueI18nOpts = {
		locale: currentLocale,
		fallbackLocale: fallbackLocale,
		messages: vueLocaleMessages,
		numberFormats: vueLocaleNumberFormats,
		silentTranslationWarn: true
	};


	let momentLocale = currentLocale;
	if (momentLocale === 'en') {
		momentLocale = 'en-gb';
	}
	moment.locale(momentLocale);

	return new VueI18n(vueI18nOpts);
}

const vueI18n = {};

export default {
	state,
	vueI18n,
	installToProxy(p) {
		p.addRequestHook(req => req.set('X-Language', vueI18n.locale));
	},
	install(Vue) {
		Vue.use(VueI18n);
		this.vueI18n = i18nInit();

		Object.defineProperties(Vue.prototype, {
			$tCaption: {
				get: function () {
					return tCaption.bind(this);
				}
			},
			$locale: {
				value: {
					state,
					actions,
				},
			},
		});
	},
}